module.exports = __webpack_public_path__ + "img/exercise.b51fe891.svg";